export default __webpack_public_path__ + "8f08a4f877e9237f02457b916d619083.png";